import { render, staticRenderFns } from "./surface_post_actions.vue?vue&type=template&id=19739f08&scoped=true&"
import script from "./surface_post_actions.vue?vue&type=script&lang=js&"
export * from "./surface_post_actions.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_actions.vue?vue&type=style&index=0&id=19739f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19739f08",
  null
  
)

export default component.exports